import { CentersTable } from "../../components/tables/CentersTable";

interface ICentersManagementProps {}

/**
 * Users management table
 * @returns
 */

export const CenterManagement = (props: ICentersManagementProps) => {
  return <CentersTable />;
};
